const axios = require("axios");

export const post = async (url, body,token) => {
    try {
        const config = {
            method: "post",
            url: url,
            headers: {
                "Content-Type": "application/json"
            },
            data: body,
        }
        if(token){
            config.headers['Authorization']=`Bearer ${token}`
        }
        const res = await axios(config)
            .then(function(response) {
                return response.data
            })
            .catch(function(error) {
                return null
            })
        return res
    } catch (error) {
        return null
    }
}

export const get = async (url) => {
    try {
        const config = {
            method: "get",
            url: url,
            headers: {
                "Content-Type": "application/json",
            }
        }
        const res = await axios(config)
            .then(function(response) {
                return response.data
            })
            .catch(function(error) {
                return error
            })
        return res
    } catch (error) {
        return error
    }
}

export const getToken = async () => {
    try {
        const config = {
            method: "get",
            url: process.env.TOKEN_URL,
            headers: {
                "Content-Type": "application/json",
                "client_id": process.env.CLIENT_ID_TOKEN,
                "client_secret": process.env.CLIENT_SECRET_TOKEN,
                "scope": process.env.SCOPE
            }
        }
        const res = await axios(config)
            .then(function(response) {
                return response.data?.access_token
            })
            .catch(function(error) {
                console.error('Error obteniendo token:', error);
                return null
            })
        return res
    } catch (error) {
        console.error('Error en getToken:', error);
        return null
    }
}